var map = {
	"./amazon.png": 3782,
	"./amiami.png": 8897,
	"./animate.png": 630,
	"./banner.gif": 4682,
	"./bg.jpg": 5917,
	"./bg.webp": 9839,
	"./bg_sp.jpg": 8495,
	"./bg_sp.webp": 8792,
	"./ebtn1.png": 3778,
	"./ebtn2.png": 4713,
	"./gs1983.png": 1042,
	"./icon_fb.png": 3375,
	"./icon_fb.webp": 147,
	"./icon_switch.png": 3082,
	"./icon_switch.webp": 618,
	"./icon_twitter.png": 6006,
	"./icon_twitter.webp": 6912,
	"./logo.png": 6949,
	"./logo.svg": 9574,
	"./logo_hachikuma.png": 5833,
	"./logo_hachikuma.webp": 8642,
	"./logo_mebius.png": 3978,
	"./logo_mebius.webp": 7639,
	"./logo_playdojin.png": 5629,
	"./logo_playdojin.webp": 6970,
	"./sofmap.png": 4499,
	"./titlelogo.png": 9849,
	"./titlelogo_v.png": 3857,
	"./titlelogo_v.webp": 6345,
	"./titlelogo_w.png": 7415,
	"./titlelogo_w.webp": 3109,
	"./tokutenall.jpg": 8362,
	"./tokutenall.webp": 4932,
	"./wngoo.png": 5801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;